import { Waves, BedDouble, UtensilsCrossed, CarFront, MapPin, Phone, Check, ArrowRight, Star } from "lucide-react";

const PHONE_DISPLAY = "388 986 8246";
const WA_LINK = `https://wa.me/393889868246?text=${encodeURIComponent(
  "Ciao Hotel Lupo di Mare, vorrei informazioni per prenotare camere con cena e pernottamento a 40€ a persona."
)}`;

const ROOMS = [
  {
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_5310cef7-f416-40a6-bbcd-7ac515270a9e/artifacts/8273035d5e9bccaf_f1df0bfd-492a-43f7-ba34-48c4677d1007.jpeg",
    caption: "Camera Singola",
    option: "Opzione 1",
    title: "Camera singola",
    testid: "room-card-singola",
  },
  {
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_5310cef7-f416-40a6-bbcd-7ac515270a9e/artifacts/d62dfb0151ada11b_f9b51b69-fafa-4e83-823f-f7e6764d377a.jpeg",
    caption: "Camera Doppia",
    option: "Opzione 2",
    title: "Camera doppia con letto matrimoniale",
    testid: "room-card-doppia",
  },
  {
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_5310cef7-f416-40a6-bbcd-7ac515270a9e/artifacts/bafab4aa24926b50_6bf11fe9-beed-4a5c-b5b8-25fa43adb2e9.jpeg",
    caption: "Camera Tripla",
    option: "Opzione 3",
    title: "Camera tripla",
    testid: "room-card-tripla",
  },
  {
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_5310cef7-f416-40a6-bbcd-7ac515270a9e/artifacts/f2b09d8e01ce4df7_d6f13f2f-47c9-47a9-9049-073790909683.jpeg",
    caption: "Camera Quadrupla",
    option: "Opzione 4",
    title: "Camera quadrupla con letto a castello",
    testid: "room-card-quadrupla",
  },
  {
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_5310cef7-f416-40a6-bbcd-7ac515270a9e/artifacts/bfd81b927c52b3ca_f7e3bcc0-6be4-46e8-8353-59275d6af599.jpeg",
    caption: "Camera Tripla",
    option: "Opzione 5",
    title: "Camera tripla con letto matrimoniale e singolo",
    testid: "room-card-tripla-matrimoniale",
  },
];

const MARQUEE_ITEMS = [
  "★ 40€ A PERSONA · CENA + PERNOTTAMENTO",
  "BERE COMPRESO",
  "PARCHEGGI GRATUITI VICINI",
  "9 CAMERE · 20/22 POSTI LETTO",
  "MARINA DI CASTAGNETO CARDUCCI (LI)",
  `WHATSAPP ${PHONE_DISPLAY}`,
];

function WhatsAppIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.04 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19.01L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 14.99 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67Z" />
    </svg>
  );
}

export default function Home() {
  return (
    <div className="ldm bg-[#faf8f5] text-[#1e293b] antialiased min-h-screen">
      {/* NAV */}
      <nav
        data-testid="main-nav"
        className="sticky top-0 z-50 bg-[#faf8f5]/95 backdrop-blur-md border-b border-[#e2dcd5] px-6 py-4 flex items-center justify-between"
      >
        <a href="#hero" data-testid="nav-logo-link" className="flex items-center gap-3 group">
          <Waves className="w-8 h-8 text-[#ea580c] shrink-0" strokeWidth={2.2} />
          <div className="flex flex-col">
            <span className="text-[#0f172a] font-bold tracking-tight text-lg leading-tight uppercase font-display">
              Hotel Lupo di Mare
            </span>
            <span className="mono-lbl text-[11px] text-[#ea580c] uppercase tracking-wider inline-flex items-center gap-1">
              <Star className="w-3 h-3 fill-[#ea580c]" /> Albergo 1 Stella · Lavoratori
            </span>
          </div>
        </a>
        <div className="flex items-center gap-6">
          <div className="hidden md:flex items-center gap-5 text-sm font-medium text-slate-700">
            <a data-testid="nav-link-offerta" href="#offerta" className="hover:text-[#ea580c] transition-colors">
              Offerta 40€
            </a>
            <a data-testid="nav-link-camere" href="#camere" className="hover:text-[#ea580c] transition-colors">
              Camere
            </a>
            <a data-testid="nav-link-posizione" href="#prenota" className="hover:text-[#ea580c] transition-colors">
              Posizione
            </a>
          </div>
          <a
            data-testid="nav-whatsapp-btn"
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#16a34a] hover:bg-[#15803d] text-white px-4 py-2 rounded-lg font-bold text-sm tracking-wide transition-colors shadow-md"
          >
            <WhatsAppIcon />
            <span className="hidden sm:inline">WhatsApp</span> {PHONE_DISPLAY}
          </a>
        </div>
      </nav>

      {/* HERO */}
      <header
        id="hero"
        className="relative bg-[#f3ede4] text-[#0f172a] px-6 py-20 md:py-28 border-b border-[#e2dcd5] overflow-hidden"
      >
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8 space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#ea580c]/10 border border-[#ea580c]/30 text-[#ea580c] mono-lbl text-xs uppercase tracking-widest font-bold">
              <span>● Tariffa Speciale Cantieri &amp; Trasfertisti</span>
            </div>

            <h1 className="text-[#0f172a] text-[clamp(40px,5.5vw,88px)] leading-[0.95] tracking-tight text-balance">
              <span className="ln"><span>CENA E</span></span>
              <span className="ln"><span>PERNOTTAMENTO</span></span>
              <span className="ln"><span className="text-[#ea580c]">A 40€ A PERSONA</span></span>
            </h1>

            <p className="d1-sub text-lg md:text-xl text-slate-700 max-w-xl font-normal leading-relaxed">
              Dormire, cenare e bere compreso con parcheggi gratuiti vicini a Marina di Castagneto Carducci.
            </p>

            <div className="d1-cta pt-4 flex flex-wrap items-center gap-4">
              <a
                data-testid="hero-whatsapp-btn"
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#ea580c] hover:bg-[#c2410c] text-white font-black px-8 py-4 rounded-xl text-lg uppercase tracking-wide transition-colors shadow-xl shadow-orange-600/20"
              >
                <span>Prenota al {PHONE_DISPLAY}</span>
                <ArrowRight className="w-5 h-5" />
              </a>
              <span className="mono-lbl text-xs text-slate-600">Accordi personalizzati per lunghi soggiorni</span>
            </div>
          </div>

          {/* Hero Price Lockup Card */}
          <div className="lg:col-span-4 bg-white border-2 border-[#ea580c] rounded-2xl p-6 md:p-8 shadow-xl relative">
            <div className="absolute -top-3 right-6 bg-[#ea580c] text-white font-black mono-lbl text-xs px-3 py-0.5 rounded uppercase">
              Tutto Incluso
            </div>
            <div className="text-slate-500 text-xs uppercase tracking-wider mono-lbl mb-2">Quota Operaio per Notte</div>
            <div className="flex items-baseline gap-1 text-[#0f172a]">
              <span className="text-6xl md:text-7xl font-black font-display text-[#ea580c]">40</span>
              <span className="text-3xl font-bold font-display">€</span>
              <span className="text-slate-600 text-sm mono-lbl">/ a persona</span>
            </div>
            <ul className="mt-6 space-y-3 border-t border-slate-200 pt-6 text-sm text-slate-800">
              <li className="flex items-center gap-3">
                <Check className="w-4 h-4 text-[#16a34a] shrink-0" strokeWidth={3} />
                <span><strong>Cena calda completa</strong></span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-4 h-4 text-[#16a34a] shrink-0" strokeWidth={3} />
                <span><strong>Pernottamento</strong> in camera singola/doppia</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-4 h-4 text-[#16a34a] shrink-0" strokeWidth={3} />
                <span><strong>Bevande incluse</strong> a cena</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="w-4 h-4 text-[#16a34a] shrink-0" strokeWidth={3} />
                <span><strong>Parcheggi gratuiti</strong> nelle vicinanze</span>
              </li>
            </ul>
          </div>
        </div>
      </header>

      {/* TICKER MARQUEE */}
      <section className="bg-[#ea580c] text-white py-3 overflow-hidden font-display font-black text-sm tracking-wider uppercase" aria-hidden="true">
        <div className="mq-track">
          {[0, 1].map((copy) => (
            <div key={copy} className="flex items-center gap-8 shrink-0 px-4">
              {MARQUEE_ITEMS.map((item, i) => (
                <span key={i} className="flex items-center gap-8">
                  <span>{item}</span>
                  <span>•</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </section>

      {/* OFFER DETAILS GRID */}
      <section id="offerta" className="bg-[#faf8f5] text-[#1e293b] py-24 md:py-32 px-6 border-b border-[#e2dcd5]">
        <div className="max-w-6xl mx-auto space-y-16">
          <div className="max-w-2xl">
            <span className="mono-lbl text-xs uppercase tracking-widest text-[#ea580c] font-bold">Nessun Costo Nascosto</span>
            <h2 className="text-3xl md:text-5xl font-black text-[#0f172a] mt-2">La Soluzione Perfetta per le Imprese</h2>
            <p className="text-slate-600 mt-4 leading-relaxed">
              Sappiamo cosa serve a chi lavora lontano da casa: un letto pulito, una doccia calda, una buona cena senza
              dover cercare ristoranti costosi, e la macchina al sicuro.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div data-testid="offer-card-cena" className="bg-white border border-[#e2dcd5] p-8 rounded-xl space-y-4 shadow-sm">
              <UtensilsCrossed className="w-8 h-8 text-[#ea580c]" strokeWidth={1.8} />
              <h3 className="text-xl font-bold text-[#0f172a] uppercase font-display">Cena Inclusa con Bevande</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Cena calda e abbondante direttamente in struttura con bere compreso, per finire il turno senza pensieri.
              </p>
            </div>

            <div data-testid="offer-card-camere" className="bg-white border border-[#e2dcd5] p-8 rounded-xl space-y-4 shadow-sm">
              <BedDouble className="w-8 h-8 text-[#ea580c]" strokeWidth={1.8} />
              <h3 className="text-xl font-bold text-[#0f172a] uppercase font-display">Riposo Tranquillo</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                9 camere semplici, fresche e funzionali per un totale di 20/22 posti letto comodi.
              </p>
            </div>

            <div data-testid="offer-card-parcheggio" className="bg-white border border-[#e2dcd5] p-8 rounded-xl space-y-4 shadow-sm">
              <CarFront className="w-8 h-8 text-[#ea580c]" strokeWidth={1.8} />
              <h3 className="text-xl font-bold text-[#0f172a] uppercase font-display">Furgoni e Auto al Sicuro</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Ampi parcheggi gratuiti nelle immediate vicinanze dell'hotel per parcheggiare furgoni e mezzi da lavoro.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ROOMS & GALLERY */}
      <section id="camere" className="bg-[#f3ede4] text-[#1e293b] py-24 md:py-32 px-6 border-b border-[#e2dcd5]">
        <div className="max-w-6xl mx-auto space-y-12">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <div>
              <span className="mono-lbl text-xs uppercase tracking-widest text-[#ea580c] font-bold">Tipologie Disponibili</span>
              <h2 className="text-3xl md:text-5xl font-black text-[#0f172a] mt-2">Le Nostre Camere</h2>
            </div>
            <div className="mono-lbl text-sm text-slate-700 bg-white px-4 py-2 rounded-lg border border-[#e2dcd5]">
              Totale: 9 Camere · 20/22 Posti Letto
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {ROOMS.map((room) => (
              <div
                key={room.testid}
                data-testid={room.testid}
                className="bg-white rounded-xl overflow-hidden border border-[#d6cec2] shadow-sm flex flex-col group"
              >
                <figure className="relative aspect-[4/3] bg-[#e6dfd5] overflow-hidden">
                  <img
                    src={room.img}
                    alt={room.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <figcaption className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/55 to-transparent">
                    <span className="text-xs uppercase tracking-wider text-white font-mono">{room.caption}</span>
                  </figcaption>
                </figure>
                <div className="p-5 flex-1 flex flex-col justify-between">
                  <div>
                    <span className="mono-lbl text-xs text-[#ea580c] font-bold uppercase">{room.option}</span>
                    <h3 className="text-lg font-bold text-[#0f172a] font-display mt-1">{room.title}</h3>
                  </div>
                  <p className="text-xs text-slate-500 mono-lbl mt-4 pt-3 border-t border-slate-100">
                    40€ a persona a notte con cena inclusa
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HONEST EMPTY TESTIMONIALS */}
      <section className="bg-[#faf8f5] text-[#1e293b] py-20 px-6 border-b border-[#e2dcd5]">
        <div className="max-w-4xl mx-auto text-center space-y-4">
          <span className="mono-lbl text-xs uppercase tracking-widest text-slate-500 font-bold">Recensioni &amp; Esperienza</span>
          <h2 className="text-2xl md:text-3xl font-bold text-[#0f172a]">L'Ospitalità Diretta Senza Fronzoli</h2>
          <div className="bg-white border border-dashed border-slate-300 p-8 rounded-xl mt-6">
            <p className="text-slate-600 text-sm leading-relaxed">
              Le recensioni delle prime squadre di lavoratori e trasfertisti verranno pubblicate qui. Trattamento
              cordiale e trasparente garantito direttamente dal gestore.
            </p>
          </div>
        </div>
      </section>

      {/* LOCATION & CONTACT CTA */}
      <section id="prenota" className="bg-[#f3ede4] text-[#1e293b] py-24 md:py-32 px-6">
        <div className="max-w-5xl mx-auto bg-white border-2 border-[#ea580c] rounded-2xl p-8 md:p-14 shadow-xl">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-7 space-y-6">
              <span className="mono-lbl text-xs uppercase tracking-widest text-[#16a34a] font-bold">● Risposta Immediata</span>
              <h2 className="text-3xl md:text-5xl font-black text-[#0f172a]">Pronti per la Tua Squadra</h2>
              <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                Sei un capocantiere, un'impresa o un lavoratore singolo? Scrivici su WhatsApp per bloccare le camere a
                40€ a persona a notte tutto compreso.
              </p>
              <div className="space-y-2 text-sm text-slate-700 mono-lbl pt-2">
                <p className="flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-[#ea580c] shrink-0" />
                  <span data-testid="contact-address">Via Firenze 1, Marina di Castagneto Carducci (LI)</span>
                </p>
                <p className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-[#16a34a] shrink-0" />
                  <span data-testid="contact-phone">WhatsApp: {PHONE_DISPLAY}</span>
                </p>
              </div>
            </div>

            <div className="md:col-span-5 flex flex-col gap-4">
              <a
                data-testid="cta-whatsapp-btn"
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 bg-[#16a34a] hover:bg-[#15803d] text-white px-8 py-5 rounded-xl font-black text-lg uppercase tracking-wide transition-colors shadow-lg text-center"
              >
                <WhatsAppIcon className="w-5 h-5" />
                <span>Contatta su WhatsApp</span>
              </a>
              <p className="text-xs text-center text-slate-500 mono-lbl">
                Più notti o intera squadra? Troviamo un accordo su misura.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#0f172a] text-slate-400 py-12 px-6 border-t border-slate-800 text-xs mono-lbl">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <span className="text-white font-bold uppercase">Hotel Lupo di Mare</span>
            <span> · Albergo 1 Stella · Marina di Castagneto Carducci</span>
          </div>
          <div>
            <span>Via Firenze 1, LI · Tel. {PHONE_DISPLAY}</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
